var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1876 14.0545C16.6924 15.2255 15.9178 16.2575 14.9317 17.0601C13.9456 17.8626 12.7778 18.4114 11.5306 18.6585C10.2833 18.9055 8.99456 18.8432 7.77694 18.4771C6.55933 18.111 5.44993 17.4522 4.54575 16.5583C3.64156 15.6644 2.97012 14.5625 2.59013 13.3492C2.21014 12.1358 2.13316 10.8479 2.36592 9.59788C2.59869 8.3479 3.13412 7.17397 3.92539 6.17872C4.71666 5.18347 5.73969 4.39721 6.90503 3.88867",
    stroke: "#28293D",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8025 11.0261C17.8025 10.0039 17.6011 8.99171 17.2099 8.04732C16.8188 7.10293 16.2454 6.24484 15.5226 5.52204C14.7998 4.79924 13.9417 4.22588 12.9973 3.8347C12.0529 3.44352 11.0408 3.24219 10.0186 3.24219V11.0261H17.8025Z",
    stroke: "#28293D",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.2bd5b396ad9ae77c831892ecd9df026c.svg";
export { ForwardRef as ReactComponent };